import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form,  setForm]  = useState({ name:'', email:'', password:'', confirm:'' });
  const [error, setError] = useState('');
  const [busy,  setBusy]  = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (form.password !== form.confirm) return setError('Passwords do not match');
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    setBusy(true);
    try { await register(form.name, form.email, form.password); navigate('/dashboard'); }
    catch(err) { setError(err.response?.data?.message || 'Registration failed'); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(160deg,#0f0e17,#1a0a30)', padding:'40px 16px' }}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border2)', borderRadius:'var(--radius-lg)', padding:'48px 40px', width:'100%', maxWidth:420, boxShadow:'var(--shadow-lg)' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <Link to="/" style={{ fontFamily:'var(--font-d)', fontSize:'1.6rem', fontWeight:700, color:'var(--text)' }}>
            Book<span style={{color:'var(--gold)'}}>Pub</span>
          </Link>
          <p style={{ color:'var(--text3)', marginTop:8, fontSize:'0.88rem' }}>Start reading for free</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          {[['Full Name','text','name','Your name'],['Email','email','email','you@example.com'],['Password','password','password','Min 6 characters'],['Confirm Password','password','confirm','Repeat password']].map(([label,type,key,ph]) => (
            <div className="form-group" key={key}>
              <label>{label}</label>
              <input className="form-control" type={type} value={form[key]} onChange={e=>setForm({...form,[key]:e.target.value})} placeholder={ph} required />
            </div>
          ))}
          <button type="submit" className="btn btn-gold" style={{width:'100%',justifyContent:'center',marginTop:8}} disabled={busy}>
            {busy ? 'Creating account…' : 'Create Account'}
          </button>
        </form>
        <p style={{ textAlign:'center', color:'var(--text3)', fontSize:'0.88rem', marginTop:24 }}>
          Have an account? <Link to="/login" style={{color:'var(--gold)',fontWeight:700}}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
